import React, { useState,useRef,useContext,useEffect} from 'react'
import './components.css'
import { Paperclip,MessageCircle,MoreVertical,PlusCircle} from 'lucide-react';
import {Modal} from '../Modal/Modal'
import  {FirebaseContext} from './firebase/firebaseContext'
import uniq from "lodash/uniq";

export const TaskForm = ({notes}) => {

    const [boards,setBoards] = useState([
        {id:1, title:"Cделать", items:[]},
        {id:2, title:"В процессе", items:[]}, 
        {id:3, title:"Сделано", items:[]}
    ])

    const [valueTaskName, setValueTaskName] = useState('')
    const [valuePriority,setValuePriority] = useState('')
    const [valueDescription,setDescription] = useState('')
    const [valueNameProcess, setNameProcess] = useState('В процессе')
    const [valueDate,setValueDate] = useState(new Date())
    const [valueDateEnd,setValueDateEnd] = useState(new Date())
    const firebase = useContext(FirebaseContext)

    const [curentBoard,  setCurrentBoard] = useState(null);
    const [curentItem,  setCurrentItem] = useState(null);
    const [modalActive,setModalActive] = useState(true);
    const [modalEditActive, setModalEditActive] = useState(false)
    const [dateValue, onDateChange] = useState(new Date());  


 
    


    const submitHandler = event => {
        event.preventDefault()
    
        if (valueTaskName.trim() || valuePriority) {
          firebase.addNote(valueTaskName.trim(),
          valuePriority,valueDateEnd,
          valueDescription,valueNameProcess).then(() => {
            console.log('Успешно отправлено', 'success')
          }).catch(() => {
            console.log('Что-то пошло не так', 'danger')
          })
      
        } else {
          console.log('Введите данные')
        }
      }
 
    function dragOverHandler(e){
        e.preventDefault();
        if(e.target.className =="item"){
            e.target.style.boxShadow = '0 2px 3px gray'
        }
    }

    function dragLeaveHandler(e){
        e.target.style.boxShadow = 'none'
    }

    function dragStartHandler(e,board,item){
        setCurrentBoard(board);
        setCurrentItem(item);
    }


    function dragEndHandler(e){
        e.target.style.boxShadow = 'none'
    }
    function dropHandler(e,board,item){
        e.preventDefault();
        const currentIndex = curentBoard.items.indexOf(curentItem);
        curentBoard.items.splice(currentIndex,1);
        const dropIndex = board.items.indexOf(item);
        board.items.splice(dropIndex + 1,0,curentItem);
        setBoards(boards.map(b=>{
            if(b.id === board.id){
                return board;
            }
            if(b.id === curentBoard.id){
                return curentBoard;
            }
            return b;
        }))

    }



  function dropCardHandler(e,board){
    board.items.push(curentItem)
    const currentIndex = curentBoard.items.indexOf(curentItem)
    curentBoard.items.splice(currentIndex,1)
    setBoards(boards.map(b=>{
        if(b.id === board.id){
            return board;
        }
        if(b.id === curentBoard.id){
            return curentBoard;
        }
        return b;
    }))
    e.target.style.boxShadow = 'none'
  }

  useEffect(()=>{
    notes.filter((note) => {
      if(note.nameProcess === "Сделать") {
        return boards[0].items.push(note)
      }
      else if(note.nameProcess === "В процессе"){
        return boards[1].items.push(note)
      }
    })
    }, [notes])

    //если нахвание такое то ты переносишь
    //через эррей пуш


  return (
    <div>
           <div className="header__project">
        <h1>Задачи</h1>
        </div>

        <div className="line"></div>
        <div className='task__form'>
        
        {boards.map(board =>
            <div className='board'
            onDragOver={(e)=> dragOverHandler(e)}
            onDrop={(e)=> dropCardHandler(e,board)}
            >
                <div className="board__title">{board.title}</div>
                <div className='board__addTask'><a href="" onClick={()=> setModalActive(true)}  ><PlusCircle/></a> </div>
                {board.items.map(item =>
                <div 
                    onDragOver={(e)=> dragOverHandler(e)}
                    onDragLeave={ e => dragLeaveHandler(e)}
                    onDragStart={(e)=> dragStartHandler(e,board,item)}
                    onDragEnd={(e)=> dragEndHandler(e)}
                    onDrop={(e)=> dropHandler(e,board,item)}
                    className="item"
                    draggable={true}
                   >
                    <div className='board__header'>
                    <div className='board__id'>{1}</div>
                    {item.task}
                    <div className='board__dateAdd' >{item.dateEnd}</div>
                    <a href="" onClick={()=> setModalEditActive(true)}> <MoreVertical /></a>  
                    </div>
                    <div className="board__discription">
                        {item.description}
                    </div>
                    <div className="board__footer">
                        <div className="board__priority">{item.priority}</div>
                        <div className="board__status">   {item.nameProcess}</div>
                        <div className="board__file"  > 
                      
                        </div>
                        <div className="board__title"> {board.title}</div>
                        <div className="board__chat"> <MessageCircle /></div>
                    </div>

                </div>
                )

                }
            </div>)}
       
    </div>
    <Modal active={modalActive} setActive={setModalActive}>
    <div class="testbox">
      <form action="/">
        <h1>Создание задачи</h1>
        <h4>Название задачи<span>*</span></h4>
        <input value={valueTaskName} 
        onChange={e => setValueTaskName(e.target.value)} type="text" name="name" />
        <h4>Приоритет<span>*</span></h4>
        <select onChange={e => setValuePriority(e.target.value)}>
          <option ></option>
          <option  value={"Выоский"} >Выоский</option>
          <option  value={"Средний"} >Средний</option>
          <option  value={"Низкий"} >Низкий</option>
        </select>
        <h4>Дата окончания</h4>
        <input value={valueDateEnd} 
        onChange={e => setValueDateEnd(e.target.value)}  type="date" id="start" name="trip-start"/>
        <h4>Описание задачи</h4>
          <textarea  value={valueDescription} 
        onChange={e => setDescription(e.target.value)}  rows="5"></textarea>
        <div class="btn-block">
       
          <button type="submit" onClick={submitHandler} href="/">Создать</button>
          <a className='modal__clip' href="">     <Paperclip /> </a>
        </div>
      </form>
    </div>
    </Modal>
    
    </div>
    
  )
}
